export interface IDailyReportResponse {
    next: string
    previous: string
    results: IDailyReportResult[]
    total?: number
}

export interface IComment {
    uuid: string
    content: string
    isActive: boolean
    createdAt: string
    createdBy: string
}

export enum Status {
    INITIATED = 'Initiated',
    OVERDUE = 'Overdue',
    PENDING = 'Pending',
    EXPIRED = 'Expired',
    COMPLETED = 'Completed',
    PAID = 'Paid',
    CONFIRMED = 'Confirmed',
}

export enum EntityType {
    ORDER = 'Order',
    RESERVATION = 'Reservation',
}

export interface IDailyReportResult {
    entityType: EntityType
    entityId: string
    entityUuid: string
    status: Status
    visitTime: string
    apfDetails: {
        buyerFirstName: string
        buyerLastName: string
        buyerEmail: string
        buyerPhoneNumber: string
    }
    products: {
        [key: string]: {
            productName: string
            quantity: number
        }
    }
    comments: IComment[]
    location: {
        id: string
        name: string
    }
}
